import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";
import { ChevronRight, CheckCircle2, AlertTriangle, Clock } from "lucide-react";
import { handoverApi } from "./handoverApi";
import { fmtDateTime } from "./imageUtils";

const Status = ({ w }) => {
  if (w.status === "in_progress") return <span className="inline-flex items-center gap-1 text-amber-700"><Clock className="w-3.5 h-3.5" />In progress</span>;
  return w.acknowledged
    ? <span className="inline-flex items-center gap-1 text-green-700"><CheckCircle2 className="w-3.5 h-3.5" />Acknowledged</span>
    : <span className="inline-flex items-center gap-1 text-slate-500"><AlertTriangle className="w-3.5 h-3.5" />Not acknowledged</span>;
};

export const WalkthroughHistoryDialog = ({ dwelling, onOpenChange }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (dwelling) handoverApi(`/dwellings/${dwelling.id}/walkthroughs`).then(setList).catch((e) => toast.error(e.message));
  }, [dwelling]);

  return (
    <Dialog open={!!dwelling} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="walkthrough-history-dialog">
        <DialogHeader>
          <DialogTitle>Walkthroughs — {dwelling?.dwelling_number}</DialogTitle>
          <DialogDescription>Open a walkthrough to see its locked record.</DialogDescription>
        </DialogHeader>
        <div className="divide-y divide-slate-100">
          {list.map((w) => (
            <button key={w.id} type="button" onClick={() => navigate(`/defects/walkthrough/${w.id}`)}
              className="w-full flex items-center justify-between gap-3 py-3 text-left hover:bg-amber-50 rounded-md px-2 transition-colors"
              data-testid={`walkthrough-history-item-${w.id}`}>
              <div className="min-w-0">
                <p className="font-semibold text-slate-900">Walkthrough #{w.sequence} · {fmtDateTime(w.started_at)}</p>
                <p className="text-sm text-slate-600">{w.client?.company_name || w.client?.name} · {w.item_count} item{w.item_count === 1 ? "" : "s"}
                  {w.added_after_count ? ` + ${w.added_after_count} added after` : ""}</p>
                <p className="text-xs mt-0.5"><Status w={w} /></p>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
